import * as XLSX from 'xlsx';

export const parseSpreadsheet = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        if (!firstSheetName) {
          resolve({ headers: [], rows: [] });
          return;
        }
        const sheet = workbook.Sheets[firstSheetName];
        const matrix = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          raw: false,
          defval: '',
          blankrows: false,
        });

        if (matrix.length === 0) {
          resolve({ headers: [], rows: [] });
          return;
        }

        const headers = matrix[0].map((h) => String(h).trim());
        const rows = [];
        for (let i = 1; i < matrix.length; i += 1) {
          const rowArr = matrix[i];
          const isEmpty = rowArr.every(
            (c) => c === '' || c === null || c === undefined
          );
          if (isEmpty) continue;
          const row = {};
          headers.forEach((h, idx) => {
            const val = rowArr[idx];
            row[h] = val === undefined || val === null ? '' : String(val).trim();
          });
          rows.push(row);
        }

        resolve({ headers, rows });
      } catch (err) {
        reject(err);
      }
    };

    reader.readAsArrayBuffer(file);
  });

export const downloadTextFile = (filename, content, mime = 'text/csv;charset=utf-8;') => {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const downloadRows = (rows, filenameBase, format = 'csv') => {
  if (!rows || rows.length === 0) return;

  if (format === 'xlsx') {
    const sheet = XLSX.utils.json_to_sheet(rows);
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, sheet, 'links');
    XLSX.writeFile(book, `${filenameBase}.xlsx`);
    return;
  }

  const headers = [];
  rows.forEach((row) => {
    Object.keys(row).forEach((k) => {
      if (!headers.includes(k)) headers.push(k);
    });
  });
  const escape = (val) => {
    const s = val === undefined || val === null ? '' : String(val);
    if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };
  const lines = [headers.map(escape).join(',')];
  rows.forEach((row) => {
    lines.push(headers.map((h) => escape(row[h])).join(','));
  });
  downloadTextFile(`${filenameBase}.csv`, lines.join('\r\n'));
};

export const CONTACT_TEMPLATE_HEADERS = ['respondent_id', 'name', 'phone', 'tag'];

export const CONTACT_TEMPLATE_SAMPLE = [
  {
    respondent_id: 'R001',
    name: 'Maria Garcia',
    phone: '+573001112233',
    tag: 'whatsapp',
  },
];

export const downloadContactTemplate = (format = 'csv', includeSample = true) => {
  const rows = includeSample
    ? CONTACT_TEMPLATE_SAMPLE
    : [Object.fromEntries(CONTACT_TEMPLATE_HEADERS.map((h) => [h, '']))];
  downloadRows(rows, 'contact_list_template', format);
};
